import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'

import { ConsentCheckbox } from '../ConsentCheckbox'
import { ConsentSection } from '../ConsentSection'
import { ConsentSectionFieldsProps } from '../types'

export function InterestLinksConsentSection({ consents, updateConsent }: ConsentSectionFieldsProps) {
  return (
    <ConsentSection title={t`Interest Links`} required>
      <p className="text-sm text-gray-600">
        <Trans>
          Promotal, the editor of this system, may have business or contractual relationships with actors in the healthcare ecosystem (medical device
          manufacturers, hosting providers, partner platforms, etc.). The full disclosure is available below.
        </Trans>
      </p>
      <a className="text-sm font-medium text-primary underline-offset-4 hover:underline" href="https://promotal-medconnect.com/liens-interet" target="_blank" rel="noopener noreferrer">
        <Trans>View interest links disclosure</Trans>
      </a>
      <ConsentCheckbox
        name="understoodInterestLinks"
        label={t`I acknowledge having read the editor's interest links disclosure.`}
        checked={consents.understoodInterestLinks}
        onChange={(checked) => updateConsent('understoodInterestLinks', checked)}
        required
      />
    </ConsentSection>
  )
}
